/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_SubtitleInputs */



/**
* | output |
* | --- |
* | "Manage your plan, usage, and billing." |
*
* @param {Sub_Dashboard_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_subtitle = /** @type {((inputs?: Sub_Dashboard_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwalten Sie Ihren Tarif, Ihre Nutzung und Abrechnung.")
	return /** @type {LocalizedString} */ ("Manage your plan, usage, and billing.")
});